export enum AuthorizationStatusType {
    New = 1,
    Pending = 2,
    Received = 3,
    Close = 4,
}
